import { useNoteTabHistoryQuery } from "src/modules/exam-preparation/graphql/noteTabs/history";
export default function useData(note, noteTabID) {
    const [historyQueryState, historyQueryActions] = useNoteTabHistoryQuery({
        variables: {
            noteTabID,
        },
    });
    const state = {
        historyQuery: historyQueryState,
    };
    const actions = {
        historyQuery: historyQueryActions,
    };
    return [state, actions];
}
